import "./_sign-flow.scss";

import {useState} from "react";

import SignFlowSendingTxnView from "./sending-txn-view/SignFlowSendingTxnView";
import SignFlowErrorView from "./error-view/SignFlowErrorView";
import SignFlowSuccessView from "./success-view/SignFlowSuccessView";
import SignFlowWaitingForSignView from "./waiting-for-sign-view/SignFlowWaitingForSignView";
import {SignFlowState, SignFlowStep} from "./SignFlow.types";

function SignFlow() {
  const [signFlowState, setSignFlowState] = useState<SignFlowState>({
    step: SignFlowStep.WaitingForSign
  });

  return <div className={"sign-flow"}>{renderContent()}</div>;

  function renderContent() {
    switch (signFlowState.step) {
      case SignFlowStep.WaitingForSign:
        return <SignFlowWaitingForSignView setSignFlowState={setSignFlowState} />;

      case SignFlowStep.SendingTxn:
        return (
          <SignFlowSendingTxnView
            signedTxns={signFlowState.signedTxns}
            setSignFlowState={setSignFlowState}
          />
        );

      case SignFlowStep.Error:
        return (
          <SignFlowErrorView
            error={signFlowState.error}
            setSignFlowState={setSignFlowState}
          />
        );

      case SignFlowStep.Success:
        return <SignFlowSuccessView data={signFlowState.data} />;

      default:
        throw new Error("Tried to render an unknown view.");
    }
  }
}

export default SignFlow;
